module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "order_toolbar toolbar pad_left",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "fuji",
    on: {
      "click": function($event) {
        _vm.show3 = !_vm.show3
      }
    }
  }, [_c('div', {
    staticClass: "goodslist1"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "5px"
    }
  }, [_vm._v("搜索/查询")]), _vm._v(" "), _c('span', {
    staticClass: "divReset",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fnReset($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/Reset.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sanjiao",
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "-10px"
    }
  })]), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show3),
      expression: "show3"
    }],
    staticStyle: {
      "padding": "0 20px 20px 20px"
    }
  }, [_c('el-form', {
    staticClass: "findform",
    staticStyle: {
      "margin-top": "10px",
      "display": "flex"
    },
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    },
    attrs: {
      "label": "询 价 单 号："
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入询价单号",
      "maxlength": "20"
    },
    model: {
      value: (_vm.filters.orderNo),
      callback: function($$v) {
        _vm.$set(_vm.filters, "orderNo", $$v)
      },
      expression: "filters.orderNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    },
    attrs: {
      "label": "询 价 城 市："
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "background": "#fff",
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择城市",
      "options": _vm.options,
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.filters.chengshi),
      callback: function($$v) {
        _vm.$set(_vm.filters, "chengshi", $$v)
      },
      expression: "filters.chengshi"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    },
    attrs: {
      "label": "询 价 状 态："
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "filterable": ""
    },
    model: {
      value: (_vm.filters.biddingStatusId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "biddingStatusId", $$v)
      },
      expression: "filters.biddingStatusId"
    }
  }, _vm._l((_vm.biddingStatusarr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-form', {
    staticClass: "findform",
    staticStyle: {
      "margin-top": "10px",
      "display": "flex"
    },
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    },
    attrs: {
      "label": "询 价 品 类："
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "filterable": ""
    },
    model: {
      value: (_vm.filters.brandTypeIds),
      callback: function($$v) {
        _vm.$set(_vm.filters, "brandTypeIds", $$v)
      },
      expression: "filters.brandTypeIds"
    }
  }, _vm._l((_vm.pinleiptions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    },
    attrs: {
      "label": "意 向 品 牌："
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "filterable": ""
    },
    model: {
      value: (_vm.filters.brandIds),
      callback: function($$v) {
        _vm.$set(_vm.filters, "brandIds", $$v)
      },
      expression: "filters.brandIds"
    }
  }, _vm._l((_vm.pinpaiptions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    },
    attrs: {
      "label": "预　　　算："
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入预算范围",
      "maxlength": "9",
      "type": "text",
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
    },
    model: {
      value: (_vm.filters.minPurchasingPrice),
      callback: function($$v) {
        _vm.$set(_vm.filters, "minPurchasingPrice", $$v)
      },
      expression: "filters.minPurchasingPrice"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "margin": "0 5px"
    }
  }, [_vm._v("至")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "请输入预算范围",
      "maxlength": "9",
      "type": "text",
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
    },
    model: {
      value: (_vm.filters.maxPurchasingPrice),
      callback: function($$v) {
        _vm.$set(_vm.filters, "maxPurchasingPrice", $$v)
      },
      expression: "filters.maxPurchasingPrice"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-form', {
    staticClass: "findform",
    staticStyle: {
      "margin-top": "10px",
      "display": "flex"
    },
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "66%",
      "display": "flex"
    },
    attrs: {
      "label": "风　　　格："
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择风格",
      "filterable": ""
    },
    model: {
      value: (_vm.filters.styleId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "styleId", $$v)
      },
      expression: "filters.styleId"
    }
  }, _vm._l((_vm.stylearr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    },
    attrs: {
      "label": "户　　　型："
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "placeholder": "室"
    },
    model: {
      value: (_vm.filters.roomId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "roomId", $$v)
      },
      expression: "filters.roomId"
    }
  }, _vm._l((_vm.roomArr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "placeholder": "厅"
    },
    model: {
      value: (_vm.filters.officeId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "officeId", $$v)
      },
      expression: "filters.officeId"
    }
  }, _vm._l((_vm.officeArr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "placeholder": "厨"
    },
    model: {
      value: (_vm.filters.kitchenId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "kitchenId", $$v)
      },
      expression: "filters.kitchenId"
    }
  }, _vm._l((_vm.kitchenArr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "placeholder": "卫"
    },
    model: {
      value: (_vm.filters.toiletId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "toiletId", $$v)
      },
      expression: "filters.toiletId"
    }
  }, _vm._l((_vm.toiletArr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "32.5%",
      "text-align": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)])], 1)]), _vm._v(" "), [_c('el-col', {
    staticClass: "order_content main_container",
    attrs: {
      "span": 24
    }
  }, [_c('section', {
    staticClass: "model_section"
  }, [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("客户询价单")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('div', {
    staticClass: "table_inner_container",
    staticStyle: {
      "height": "auto"
    }
  }, [_c('el-table', {
    staticStyle: {
      "height": "auto",
      "max-height": "500px"
    },
    attrs: {
      "data": _vm.dataList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "询价单号",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.OrderNo,
            "label": scope.row.OrderNo
          }
        }, [_vm._v(_vm._s(scope.row.OrderNo))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "所在城区",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.Address,
            "label": scope.row.Address
          }
        }, [_vm._v(_vm._s(scope.row.Address))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "房屋面积",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.BuildingArea,
            "label": scope.row.BuildingArea
          }
        }, [_vm._v(_vm._s(scope.row.BuildingArea))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "户型",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.HouseType,
            "label": scope.row.HouseType
          }
        }, [_vm._v(_vm._s(scope.row.HouseType))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "询价品类",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.BrandType,
            "label": scope.row.BrandType
          }
        }, [_vm._v(_vm._s(scope.row.BrandType))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "预算",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.Budget,
            "label": scope.row.Budget
          }
        }, [_vm._v(_vm._s(scope.row.Budget))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "询价状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.StatusName,
            "label": scope.row.StatusName
          }
        }, [_vm._v(_vm._s(scope.row.StatusName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "报价次数",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.QuoteCount,
            "label": scope.row.QuoteCount
          }
        }, [_vm._v(_vm._s(scope.row.QuoteCount))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.seeOrder(scope.row.Id)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-view"
        }), _vm._v("查看\r\n                  ")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "margin": "10px 0",
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageIndex,
      "page-size": 10,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])], _vm._v(" "), _c('InquiryDetails', {
    ref: "refInquiryDetails"
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-741bccae!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/orderManagement/LowPriceManagement.vue
// module id = 1709
// module chunks = 3